import * as React from 'react';
import { TextField, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';

interface attendeeRecordProps {
  alternatePriority: string;
}

interface IAlternatePriorityProps {
  attendeeRecord: attendeeRecordProps;
  handleFormChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const AlternatePriority: React.FC<IAlternatePriorityProps> = (props) => {
  return (
    <Grid size={{ xs: 12 }} className="pt-3 pb-3">
      <Grid size={{ xs: 12, sm: 12, md: 7, lg: 8 }}>
        {/* Left Container */}
        <Typography variant="h2">Alternate Priority</Typography>
      </Grid>

      <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }} className="pt-4">
        <Typography variant="subtitle2">
          List in the order in which this alternate will be seated (Alternate 1
          will be seated before Alternate 2, etc.).
        </Typography>
        <Grid size={{ xs: 12 }} className="pt-2">
          {' '}
          <TextField
            fullWidth={true}
            value={props.attendeeRecord.alternatePriority}
            onChange={props.handleFormChange}
            variant="outlined"
            label="Alternate Priority"
            name="alternatePriority"
            required={true}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AlternatePriority;
